module.exports = __webpack_public_path__ + "img/cover.a87a26c2.jpg";